import React, {useEffect, useState, useCallback, useContext } from "react";
import { isMobile, MobileView } from "react-device-detect";
import { Sale } from "./Sale";
import { useFetch } from "../../api/FetchApiData";
import Select from "react-select";
import {QRScanner} from "../../utils/QrCodeScan";
import { useInfiniteScroll } from "../../utils/InfiniteScroll";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import OrdersMap from "../../map/orders/OrdersMap";
import { UserContext } from "../../../AppContextProvider";
import search_icon from "../../icons/searchbar_gray.png";

if (isMobile)
    import('./sales_mob.css').then(() => {});
else
    import('./sales.css').then(() => {});


export default function Sales({User,setUser})
{
    const [sales,setSales] = useState([]);
    const [scanner,setScanner] = useState({display:false,package_ticket:null,customer_ticket:null,type:'',notification:""});
    const [filters,setFilters] = useState({display:'none',btn:'+'});
    const [notification,setNotification] = useState({text:'',color:'black',display:'none'});
    const [page,setPage] = useState({CurrentPage:1,MaxPage:1});
    const [hasMore,setHasMore] = useState(true);
    const [viewIsMap, setViewIsMap] = useState({status:false,order:null});
    const [UserState,setUserState] = useContext(UserContext);
    const [users_filter,setUsers_filter] = useState([]);
    const fetchData = useFetch();
    let customStyles = {
        control: (provided) => ({
          ...provided,
        }),
        option: (provided) => ({
          ...provided,
        }),
        singleValue: (provided) => ({
          ...provided,
        }),
      };
    
    if(isMobile)
        customStyles = {
            control: (provided) => ({
              ...provided,
              fontSize: 'small', // control font size
            }),
            option: (provided) => ({
              ...provided,
              fontSize: 'small', // dropdown option font size
            }),
            singleValue: (provided) => ({
              ...provided,
              fontSize: 'small', // selected value font size
            }),
          };


    const FetchPartners = useCallback(async ()=>{
        if(page.CurrentPage<=page.MaxPage)
        {
            fetchData.PostData({},`sales/filter/${page.CurrentPage}/`).then((result)=>{
                if(result.result)
                {
                    if(page.CurrentPage>result.maxpage)
                        setHasMore(false);
                    else
                    {setSales([...sales,...result.sales]);setPage({...page,CurrentPage:page.CurrentPage+1,MaxPage:result.maxpage});}
                }
            })
        }
    },[page.CurrentPage]);

    const SearchUser = (value,action)=>{
        if(value==='')
            return;

        const get_main_address = (user)=>{
            let address = user.locations.find(location=>location.is_main);
            if(address===undefined && user.locations.length>0)
                address = user.locations[0];
            else 
                return 'Inconnue';
            return address.display_name;
            
        }

        const data_ = {page:1,filters:{input:value,type:'label_name'},'origin-page':'sales'};
        fetchData.PostData(data_,'user/users/').then((result)=>{
            if(result.result)
            {
                const options = result.users.map((user)=>{
                    return({value:user.id,
                    label:<div>
                            <label style={{margin:'0px',fontSize:'x-small',fontWeight:'blod',display:'block'}}>{user.labelname}</label>
                            { !!user.phone && user.phone!=='' && <span style={{fontSize:'x-small',color:'gray'}}>Phone : {user.phone}</span>}
                            <span style={{fontSize:'x-small',color:'gray',display:'block'}}>Email : {user.email}</span>
                            <span style={{fontSize:'x-small',color:'gray',display:'block'}}>Adresse : {get_main_address(user)}</span>
                    </div>})
                });
                setUsers_filter(options);
            }
        });
    }

    const LoadMoreRef = useInfiniteScroll(FetchPartners,hasMore);

    const displayFilters = ()=>
    {
        if(filters.display==='none')
            setFilters({...filters,display:'block',btn:'-'})
        else
            setFilters({...filters,display:'none',btn:'+'})
    }

    const onScan = async (data)=>{
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        const data_ = {meta:'qrcode',ticket:data,type:scanner.type, device: result['visitorId']}
        fetchData.PostData(data_,'sales/status/').then((result)=>{
            if(result.result)
            {
                setSales([result.order]);
                if(scanner.type==='costumer_ticket')
                    setScanner({...scanner,display:false,customer_ticket:result.order.ticket})
                else
                    setScanner({...scanner,display:false,package_ticket:result.order.ticket})
            }
            else
            {
                setScanner({...scanner,display:false})
                setNotification({text:result.error,display:'block',color:'orangered'});
                setTimeout(()=>{
                    setNotification({text:'',display:'none',color:'black'});
                },10000)
            }
        });
    }

    return(<div className="sales">
        <div style={{width:'100%', position:'relative'}}>
            {  User.is_staff && 
                <>
                    <div className="sales-filters-title">
                        <input onClick={e=>{displayFilters()}} style={{border:'none'}} className="sales-filter-title-btn" type="button" value={filters.btn} />
                        <label className="sales-filter-title-label">Filtres</label>
                    </div>
                    <fieldset style={{display:filters.display}} className="sales-filters">
                        <div className="sales-champs">
                        <label className="sales-champs-label">Utilisateurs : </label>
                            <Select isSearchable filterOption={null} options={users_filter}  onInputChange={(value,action)=>{SearchUser(value,action)}} placeholder='choisir une periode' className="sales-filter-control" styles={customStyles} />
                        </div>
                        <div className="sales-champs">
                            <label className="sales-champs-label">Partenaires : </label>
                            <Select isSearchable={true} placeholder='choisir un partenaire' className="sales-filter-control" styles={customStyles} />
                        </div>
                        <div className="sales-champs">
                            <label className="sales-champs-label">Status : </label>
                            <Select isSearchable={false} placeholder='choisir un status' className="sales-filter-control" styles={customStyles} />
                        </div>
                        <div className="sales-champs">
                            <label className="sales-champs-label">Ville : </label>
                            <Select isSearchable={false} placeholder='choisir une ville' className="sales-filter-control" styles={customStyles} />
                        </div>
                    </fieldset>
                </>
            }
            <div className="sales-search" style={{border:'1px solid lightgray',borderRadius:'5px',marginTop:'10px'}}>
                <input className="sales-search-control" type="search" placeholder="Reference" />
                <img id="sales-filtres-qrscan" src={search_icon} style={{height:'30px',verticalAlign:'middle',float:'right'}} />
            </div>
            {(User.is_staff || User.is_deliver) && <input onClick={e=>{setViewIsMap({...viewIsMap,status:!viewIsMap.status})}} type="button" value={'Map'} style={{margin:'auto',marginTop:'8px',border:'none',backgroundColor:'goldenrod',color:'black',minHeight:'40px',paddingTop:'5px',display:'block',width:'28%',display:'inline-block',marginRight:'10px',borderRadius:'5px'}} />}
            {(User.is_staff || User.is_partner) && <input onClick={e=>{setScanner({...scanner,display:true,type:'costumer_ticket',notification:"Veuillez scanner le QR Code du ticket client"})}} type="button" value={'Ticket client'} style={{margin:'auto',marginTop:'8px',border:'none',backgroundColor:'goldenrod',color:'black',minHeight:'40px',paddingTop:'5px',display:'block',width:'28%',display:'inline-block',marginRight:'10px',borderRadius:'5px'}} />}
            <input onClick={e=>{setScanner({...scanner,display:true,type:'package_ticket',notification:"Veuillez scanner le QR Code sur le colis"})}} type="button" value={'Colis'}  style={{margin:'auto',marginTop:'8px',border:'none',backgroundColor:'goldenrod',color:'black',minHeight:'40px',paddingTop:'5px',display:'block',width:'28%',display:'inline-block',borderRadius:'5px'}} />
            <div className="sales-notification">
                <p style={{margin:'auto',color:notification.color,marginTop:'10px',display:notification.display}}>
                    {notification.text}
                </p>
            </div>

            { !viewIsMap.status && 
              <div className="sales-div">{
                sales.map((order,index)=>{ 
                    return(<Sale ShowMap={setViewIsMap} SetScanner={setScanner} Scanner={scanner} User={User} order={order} key={index} />);
                })}
                </div>
            }
            {!viewIsMap.status && <div ref={LoadMoreRef} style={{height:'20px'}}/>}
            { viewIsMap.status && (<OrdersMap order={viewIsMap.order} close={()=>{setViewIsMap({status:false,order:null})}} />) }
        </div>
        {scanner.display && <QRScanner notification={scanner.notification} close={()=>{setScanner({...scanner,display:false})}} onScan={(data)=>{onScan(data);}} />}
    </div>);
}

